import { Component, OnInit } from '@angular/core';
import TournamentBase from '../../tournament-base';
import { filtersAllMock, tournamentsMock } from './all.mock';

@Component({
    selector: 'app-tournament-all',
    templateUrl: './all.component.html',
    styleUrls: ['./all.component.scss'],
})
export class TournamentAllComponent extends TournamentBase implements OnInit {
    filters;
    tournamentsMonths;
    statusCode: number;

    loading: boolean = false;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.getTournaments(null);
    }

    getTournaments(filters = null) {
        this.loading = true;

        this.tournamentService.getAllTournaments(filters).subscribe(
            (tournaments) => {
                this.loading = false;
                this.filters = tournaments.registers.filters;
                this.tournamentsMonths = tournaments.registers.list;
                this.statusCode = tournaments.status_code;
            },
            () => {
                this.loading = false;
            }
        );
    }

    onFiltersChange(filters) {
        this.getTournaments(filters);
    }
}
